export default __webpack_public_path__ + "b6a39f3c9d27f89ece46cc3f3f0f35ae.webp";